import React, { useState } from 'react';
import './ServiceInformation.scss';
import DynaSelectBox from '../../../../A13/DynaView/DynaSelectBox';
import DynaInput from '../../../../A13/DynaView/DynaInput';
import { TrashSVG } from '../../../ChikaExportSvg/ChikaExportSvg';
import UtilsFunctions from '../../../../../utils/UtilsFunctions';
import { toast } from 'react-toastify';

const ServiceInformation = ({ sendData, setSendData, serviceOptions = [] }) => {
  const [newService, setNewService] = useState({
    id_service: '',
    service_name: '',
    price: ''
  });

  // ====================  بروزرسانی خودکار فیلدهای خدمت فقط هنگام انتخاب جدید ====================
  const handleServiceChange = (selectedValue) => {
    const service = serviceOptions.find((s) => s.value === selectedValue);

    if (service) {
      setNewService((prev) => ({
        ...prev,
        id_service: selectedValue,
        service_name: service.label,
        price: service.price || 0
      }));
    }
  };

  // ====================  مدیریت تغییرات دستی در فرم افزودن خدمت ====================
  const handleChange = (name, value) => {
    setNewService((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // ==================== افزودن خدمت به لیست خدمات ====================
  const handleAddService = () => {
    const { id_service } = newService;

    const validations = {
      'لطفاً یک خدمت انتخاب کنید.': !id_service,
      'این خدمت قبلاً اضافه شده است.': sendData.services.some((s) => +s.id_service === +id_service)
    };

    for (const [message, condition] of Object.entries(validations)) {
      if (condition) return toast.error(message);
    }

    setSendData((prev) => ({
      ...prev,
      services: [...prev.services, newService]
    }));

    setNewService({
      id_service: '',
      service_name: '',
      price: ''
    });
  };

  // ==================== حذف خدمت از لیست ====================
  const handleDeleteService = (index) => {
    setSendData((prev) => ({
      ...prev,
      services: prev.services.filter((_, i) => i !== index)
    }));
  };

  // ==================== به‌روزرسانی فیلدهای قابل ویرایش در جدول ====================
  const handleTableChange = (index, field, value) => {
    const numericValue = UtilsFunctions.removeCommas(value).replace(/\D/g, "");

    setSendData((prev) => ({
      ...prev,
      services: prev.services.map((service, i) =>
        i === index ? { ...service, [field]: numericValue } : service
      )
    }));
  };

  // ==================== محاسبه جمع کل خدمات ====================
  const calculateTotal = () => {
    return sendData.services.reduce((sum, service) => sum + Number(service.price), 0);
  };

  return (
    <div className='service__information'>
      <div className='form__grid'>
        <DynaSelectBox
          options={serviceOptions}
          hasFilter={false}
          label='انتخاب خدمت'
          className='solid-dyna-input'
          value={newService.id_service}
          onChange={(data) => handleServiceChange(data.value)}
        />
        <div className='group__flex'>
          <DynaInput
            label='مبلغ خدمت'
            name='price'
            className='solid-dyna-input'
            placeholder='مقدار فی را وارد کنید'
            value={UtilsFunctions.addCommas(newService.price)}
            type='text'
            setDataFromComponent={(data) => handleChange('price', data.price)}
            hasComma={true}
            disabled={!newService.id_service}
          />
          <button className='add__button' onClick={handleAddService}>
            افزودن
          </button>
        </div>
      </div>

      <div className='table__section'>
        <div className='table__box'>
          <ul className='table__header'>
            <li className='table__row'>
              <div style={{ width: '70%' }} className='table__cell'>نام خدمت</div>
              <div style={{ width: '15%' }} className='table__cell'>مبلغ خدمت</div>
              <div style={{ width: '15%' }} className='table__cell'>عملیات</div>
            </li>
          </ul>
          <ul className='table__body'>
            {sendData.services.length > 0 ? (
              sendData.services.map((service, index) => (
                <li key={index} className='table__row'>
                  <div style={{ width: '70%' }} className='table__cell'>{service.service_name}</div>
                  <div style={{ width: '15%' }} className='table__cell'>
                    <input
                      type='text'
                      value={UtilsFunctions.addCommas(service.price)}
                      onChange={(e) => handleTableChange(index, 'price', e.target.value)}
                      onFocus={() => service.price == 0 && handleTableChange(index, "price", "")}
                      onBlur={() => service.price == "" && handleTableChange(index, "price", "0")}
                    />
                  </div>
                  <div style={{ width: '15%' }} className='table__cell operation'>
                    <button className='trash__button' onClick={() => handleDeleteService(index)}>
                      <TrashSVG />
                    </button>
                  </div>
                </li>
              ))
            ) : (
              <p className='table__empty'>اطلاعاتی موجود نیست</p>
            )}
          </ul>
        </div>
      </div>

      {sendData.services.length > 0 && (
        <div className='payment__price'>
          <div className='payment__total'>
            <span>جمع کل</span>
            <span>{UtilsFunctions.addCommas(calculateTotal())}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceInformation;